import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./goldify.css";
import CustomButton from "../../components/CustomButton";

function Invoice() {
  const location = useLocation();
  const data = location?.state?.buyData;

  const provider = location.state.provider === "augmont" ? true : false;

  if (provider) {
    var {
      metalType,
      rate,
      preTaxAmount,
      quantity,
      totalAmount,
      transactionId,
      uniqueId,
      invoiceNumber,
    } = data?.data?.[0]?.result?.data || {};

    var { totalTaxAmount } = data?.data?.[0]?.result?.data?.taxes || {};

    var { invoicePath } = data?.data?.[0] || {};
  } else {
    var {
      metalRate,
      quantity,
      taxAmount,
      totalAmount,
      transactionId,
      invoiceId,
    } = data?.data || {};

    var { invoicePDF } = data || {};
  }

  const [updatedInvoicePath, setUpdatedInvoicePath] = useState("");

  useEffect(() => {
    if (invoicePath) {
      if (invoicePath.includes("https://app.batuk.in/")) {
        const newPath = invoicePath.replace("https://app.batuk.in/", "");
        setUpdatedInvoicePath(newPath);
      } else {
        setUpdatedInvoicePath(invoicePath);
      }
    }
  }, [invoicePath]);

  return (
    <main
      className="invoice_container universal_card"
      style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
    >
      {/* ====HEADER==== */}
      <div
        style={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          border: "2px solid #E3B041",
          borderRadius: "10px",
        }}
      >
        <div className="col-md-2 ">
          <img
            src={
              location?.state?.provider === "augmont"
                ? metalType === "gold"
                  ? "/images/gold_shield.png"
                  : "/images/silver_shield.png"
                : "/images/mmtc_logo.png"
            }
            alt="shield"
            className="img-fluid"
            style={{ height: "80px" }}
          />
        </div>
        <div className="col-md-4   p-2 ml-5 " style={{ height: "auto" }}>
          <h3 className="text-center">
            {location.state.provider == "augmont" ? "Augmont" : "MMTC"}
          </h3>
        </div>
      </div>

      {/* ====DETAILS==== */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <h4 className="fw-bold ">Payment Details</h4>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>Bought Rate</div>
          <div>₹{provider ? rate : metalRate}</div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>Weight</div>
          <div>{quantity}gm</div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {/* <div>Rate of {location?.state?.metal || "gold"}</div> */}
          <div>Rate of {metalType == "gold" ? "gold" : "silver" || "gold"}</div>
          <div>₹{provider ? preTaxAmount : metalRate}</div>
        </div>
        {/* {totalTaxAmount || */}
        {/* (taxAmount && ( */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>GST</div>
          <div>₹{provider ? totalTaxAmount : taxAmount}</div>
        </div>
        {/* ))} */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h5>Total Amount</h5>
          <h5>₹{totalAmount}</h5>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div> Transaction Id</div>
          <div>{transactionId}</div>
        </div>
        {uniqueId && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>Unique Id</div>
            <div>{uniqueId}</div>
          </div>
        )}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>Invoice Number </div>
          <div>{provider ? invoiceNumber : invoiceId}</div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h5>Status</h5>
          <h5 style={{ color: "green" }}>SUCCESS</h5>
        </div>
      </div>

      {/* ====INVOICE==== */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <a
          href={provider ? updatedInvoicePath : invoicePDF}
          target="_blank"
          rel="noopener noreferrer"
        >
          <CustomButton label="Invoice" outLined={true} />
        </a>
      </div>
    </main>
  );
}
export default Invoice;
